import type { RouteRecordRaw } from 'vue-router'

import { ROUTES } from '~/scopes/auth/route-names'

import { CHECKOUT_E_COMMERCE } from './route-names'

const routes: RouteRecordRaw[] = [
  {
    path: 'f2',
    name: CHECKOUT_E_COMMERCE.SELF,
    component: () =>
      import(
        '@backmarket/nuxt-layer-checkout/components/CheckoutFlow/CheckoutFlow.vue'
      ),
    redirect: { name: CHECKOUT_E_COMMERCE.CART },
    meta: {
      owners: ['bot-squad-checkout-front'],
      layout: false,
    },
    children: [
      {
        name: CHECKOUT_E_COMMERCE.CART,
        path: 'cart',
        component: () =>
          import(
            '~/scopes/checkout/flows/e-commerce/pages/CartStep/CartStep.vue'
          ),
        meta: {
          owners: ['bot-squad-checkout-front'],
          gtmStepId: 1,
        },
      },
      {
        path: 'addresses',
        name: CHECKOUT_E_COMMERCE.ADDRESSES,
        component: () =>
          import(
            '~/scopes/checkout/flows/e-commerce/pages/AddressesStep/AddressesStep.vue'
          ),
        meta: {
          owners: ['bot-squad-checkout-front'],
          auth: {
            required: true,
            redirection: {
              name: ROUTES.AUTH.LOGIN,
              query: { bm_journey: 'checkout' },
            },
          },
          gtmStepId: 4,
        },
      },
      {
        path: 'services/bouygues-telecom',
        name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.ROOT,
        redirect: { name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.SIGN_UP },
        meta: {
          owners: ['bot-squad-b2cservices-front'],
          auth: {
            required: true,
            redirection: {
              name: ROUTES.AUTH.LOGIN,
              query: { bm_journey: 'checkout' },
            },
          },
        },
        children: [
          {
            path: 'sign-up',
            name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.SIGN_UP,
            component: () =>
              import(
                '~/scopes/checkout/flows/e-commerce/pages/BouyguesSignUp/BouyguesSignUp.vue'
              ),
            meta: {
              owners: ['bot-squad-b2cservices-front'],
            },
          },
          {
            path: 'phoneline-setup',
            name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.PHONELINE_SETUP,
            component: () =>
              import(
                '~/scopes/checkout/flows/e-commerce/pages/BouyguesPhonelineSetup/BouyguesPhonelineSetup.vue'
              ),
            meta: {
              owners: ['bot-squad-b2cservices-front'],
            },
          },
          {
            path: 'not-eligible',
            name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.NOT_ELIGIBLE,
            component: () =>
              import(
                '~/scopes/checkout/flows/e-commerce/pages/BouyguesPhonelineSetup/components/NotEligible/NotEligible.vue'
              ),
            meta: {
              owners: ['bot-squad-b2cservices-front'],
            },
          },
        ],
      },
      {
        path: 'payment',
        name: CHECKOUT_E_COMMERCE.PAYMENT,
        component: () =>
          import(
            '~/scopes/checkout/flows/e-commerce/pages/PaymentStep/PaymentStep.vue'
          ),
        meta: {
          owners: ['bot-squad-checkout-front'],
          auth: {
            required: true,
            redirection: {
              name: ROUTES.AUTH.LOGIN,
              query: { bm_journey: 'checkout' },
            },
          },
          payment: {
            contentSecurityPoliciesEnabled: true,
          },
          gtmStepId: 6,
        },
      },
    ],
  },
  {
    path: 'f2/payment-result/:paymentId?',
    name: CHECKOUT_E_COMMERCE.PAYMENT_RESULT,
    component: () => import('~/scopes/checkout/pages/Result/Result.vue'),
    meta: {
      owners: ['bot-squad-checkout-front'],
      auth: {
        required: true,
        redirection: {
          name: ROUTES.AUTH.LOGIN,
          query: { bm_journey: 'checkout' },
        },
      },
    },
  },
  {
    path: 'f2/services/bouygues-telecom/auth',
    name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.AUTH,
    component: () =>
      import(
        '~/scopes/checkout/flows/e-commerce/pages/BouyguesAuthentication/BouyguesAuthentication.vue'
      ),
    meta: {
      layout: 'minimal',
      owners: ['bot-squad-b2cservices-front'],
    },
  },
]

export default routes
